<template>
    <v-menu ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field v-model="date"
                          :rules="rules"
                          placeholder="tap here to select date"
                          readonly
                          clearable
                          outlined
                          prepend-inner-icon="mdi-calendar-outline"
                          v-on="on"
                          :error="customError"
                          :error-messages="customErrorMessage"
                          :disabled="controlDisabled==true"></v-text-field>
        </template>
        <v-date-picker ref="picker"
                       v-model="date"
                       :max="new Date().toISOString().substr(0, 10)"
                       min="1900-01-01"
                       @change="save"></v-date-picker>
    </v-menu>
</template>
<script>
    /* eslint-disable */

    import moment from "moment";
    export default {
        props: [
            "value",
            "required",
            "dataItemId",
            "controlDisabled",
            "minAge",
            "maxAge",
            "error",
            "error-messages",

            "rules"
        ],
        data() {
            return {
                menu: false,
                errorMessage: ""
            };
        },
        watch: {
            menu: function (val) {
                val && setTimeout(this.setPicker);
            }
        },
        computed: {
            date: {
                get: function () {
                    return this.value;
                },
                set: function (value) {
                    this.$emit("input", value);
                }
            },
            customError: function () {
                if (this.required && !this.date) {
                    this.errorMessage = "This is required";
                    this.$store.commit("appendErrorItem", { id: this.dataItemId, msg: this.errorMessage });
                    return true;
                }
                let currentAge = moment().diff(this.date, "years");
                if(this.minAge && currentAge > 120) {
                    this.errorMessage = `Age calculated (${currentAge}) must be less or equal to 120 years`;
                    this.$store.commit("appendErrorItem", { id: this.dataItemId, msg: this.errorMessage });
                    return true;
                } else if (this.minAge && this.maxAge) {
                    this.errorMessage = `Age calculated (${currentAge}) must be between ${this.minAge} and ${this.maxAge} years`;
                    if (currentAge < this.minAge || currentAge > this.maxAge) {
                        this.$store.commit("appendErrorItem", { id: this.dataItemId, msg: this.errorMessage });
                        return true;
                    }
                } else if (this.minAge) {
                    if (currentAge < this.minAge) {
                        this.errorMessage = `Age calculated (${currentAge}) must be greater or equal to ${this.minAge} years`;
                        this.$store.commit("appendErrorItem", { id: this.dataItemId, msg: this.errorMessage });
                        return true;
                    }
                } else if (this.maxAge) {
                    if (currentAge > this.maxAge) {
                        this.errorMessage = `Age calculated (${currentAge}) must be less or equal to ${this.maxAge} years`;
                        this.$store.commit("appendErrorItem", { id: this.dataItemId, msg: this.errorMessage });
                        return true;
                    }
                } 

                this.$store.commit("removeErrorItem", {
                    id: this.dataItemId,
                    msg: this.errorMessage
                });
                return false;
            },
            customErrorMessage: function () {
                if (this.customError) {
                    return this.errorMessage;
                } else {
                    return "";
                }
            }
        },
        methods: {
            setPicker: function () {
                this.$refs.picker.activePicker = "YEAR";
            },
            save: function (date) {
                this.$refs.menu.save(date);
                this.$emit("change");
            }
        },
        beforeDestroy: function () {
            this.$store.commit("removeErrorItem", {
                id: this.dataItemId,
                msg: this.errorMessage
            });
        }
    };
</script>
<style>
    .custom-date-picker {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
    }

    .custom-date-picker-validation {
        font-size: 12px;
    }
</style>




